import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getBankInfo = async (appId: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/initialbankinfo?appId=${appId}`
  );

  return data;
};

export const updateBankInfo = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/initialbankinfo?appId=${appId}`,
    updateInfo
  );

  return data;
};
